import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import StatsGrid from '../components/StatsGrid';
import ActivityList from '../components/ActivityList';
import Funnel from '../components/Funnel';
import { getDashboardData } from '../services/mockApi';
import { useNavigate } from 'react-router-dom';

export default function Dashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

   const navigate = useNavigate();

  useEffect(() => {
        const userId = localStorage.getItem('user');

        console.log(userId);

        if (!userId) {
            console.log('Usuário não está logado');
            navigate('/login');
        }
    }, []);

  useEffect(() => {
    let mounted = true;
    getDashboardData().then((d) => {
      if (mounted) {
        setData(d);
        setLoading(false);
      }
    });
    return () => (mounted = false);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">Carregando dashboard...</div>
    );
  }

  return (
    <div className="flex bg-gray-50 min-h-screen">
      <Sidebar />

      <div className="flex-1">
        <Topbar user={data.user} />

        <main className="p-6 max-w-7xl mx-auto">
          <section className="mb-6">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="lg:col-span-2">
                <StatsGrid stats={data.stats} />
              </div>
              <div className="space-y-6">
                <div className="bg-white rounded-2xl p-5 shadow-sm border">
                  <h3 className="text-lg font-medium mb-4">Atalho rápido</h3>
                  <div className="grid grid-cols-3 gap-3">
                    <button className="bg-purple-50 text-purple-600 p-3 rounded-lg">Novo projeto</button>
                    <button className="bg-green-50 text-green-600 p-3 rounded-lg">Gerar contrato</button>
                    <button className="bg-yellow-50 text-yellow-600 p-3 rounded-lg">Importar arquivos</button>
                  </div>
                </div>

                <Funnel items={data.funnel} />
              </div>
            </div>
          </section>

          <section className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <ActivityList activities={data.activities} />

            <div className="space-y-6">
              <div className="bg-white rounded-2xl p-5 shadow-sm border">
                <h3 className="text-lg font-medium mb-4">Lembretes importantes</h3>
                <div className="grid grid-cols-1 gap-3">
                  {data.reminders.map((r) => (
                    <div key={r.id} className="flex items-center justify-between p-3 rounded-lg border">
                      <div>
                        <div className="font-medium">{r.text}</div>
                        <div className="text-sm text-gray-500">{r.hint}</div>
                      </div>
                      <div className="text-sm text-gray-400">›</div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-white rounded-2xl p-5 shadow-sm border">
                <h3 className="text-lg font-medium mb-4">Atividades recentes</h3>
                <p className="text-sm text-gray-500">Últimas ações realizadas na sua conta.</p>
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}
